import { Icon } from '@iconify/react';

function App(props) {

  var index = props.index;
  var tabWidth = props.tabWidth;
  var clickTab = props.clickTab;
  var anElement = props.anElement;
  var highlightAnItem = props.highlightAnItem;
  var tabSelectedIndex = props.tabSelectedIndex;

  var borderTopRightRadius = 0;
  var borderBottomRightRadius = 0;

  var style = {width:tabWidth, height:tabWidth, padding:10, paddingLeft:12, textAlign:'center', fontSize:'0.8em', cursor:'pointer'};

  var className5 = 'leftMenuIcons';
  if (index === tabSelectedIndex){
    className5 = 'leftMenuIconsSelected';
  }else{
    if (index === tabSelectedIndex -1  ){
      borderBottomRightRadius = 5;
    }else if (index === tabSelectedIndex + 1  ){
      borderTopRightRadius = 5;
    }
    if (anElement.e){
      style.color = 'red';
    }
    if (highlightAnItem && highlightAnItem.t === 'leftPanel' && highlightAnItem.v === anElement.t){
      style.backgroundColor = 'blue';
    }
  }
  style.borderTopRightRadius = borderTopRightRadius;
  style.borderBottomRightRadius = borderBottomRightRadius;


  return <tr key={index}><td style={style} className={className5 + ' noBorder'} onClick={clickTab(anElement, index)}>
      <Icon height = "20" icon={anElement.a} /><br/>    
      {anElement.n}
    </td></tr>
}

export default App;
